<template>
  <div ref="tableWrapper" class="table-wrapper prepare hidden">
    <table ref="tableHeader" class="table-header"></table>
    <table ref="table" class="table-body">
      <thead ref="thead">
      <slot name="header"></slot>
      </thead>
      <tbody ref="tbody">
      <slot></slot>
      </tbody>
    </table>
  </div>
</template>

<script>
import CommonUtil from '../../utils/common'

export default {
  name: 'FixedHeaderTableCmp',
  components: {},
  props: {
    fixed: {type: Boolean, default: false}
  },
  data () {
    return {
      fixedColumnWidths: []
    }
  },
  mounted () {
    if (this.fixed) {
      this.$nextTick(() => {
        if (this.$el.hidden) return
        if (CommonUtil.isEmpty(this.fixedColumnWidths)) {
          this.calcColumnWidths()
        }
        this.fixedLayout()
      })
    }
  },
  beforeUpdate () {
    if (this.fixed) {
      this.$nextTick(() => {
        if (this.$el.hidden) return
        if (CommonUtil.isEmpty(this.fixedColumnWidths)) {
          this.calcColumnWidths()
        }
        this.fixedLayout()
      })
    }
  },
  beforeDestory () {
    if (CommonUtil.isNotEmpty(this.fixedColumnWidths)) {
      this.$refs.table.removeEventListener('scroll', this.onScrollTable)
      this.fixedColumnWidths = []
    }
  },
  methods: {
    calcColumnWidths () {
      this.$refs.tableWrapper.classList.remove('hidden')
      this.fixedColumnWidths = []
      for (let element of this.$refs.thead.children[0].children) {
        this.fixedColumnWidths.push(element.clientWidth)
      }
      this.$refs.thead.parentElement.removeChild(this.$refs.thead)
      this.$refs.tbody.parentElement.removeChild(this.$refs.tbody)
      this.$refs.tableWrapper.classList.add('hidden')
    },
    fixedLayout () {
      for (let i = 0, len = this.fixedColumnWidths.length; i < len; i++) {
        let element = this.$refs.thead.children[0].children[i];
        (element).style.width = `${this.fixedColumnWidths[i]}px`
      }

      for (let rowElement of this.$refs.tbody.children) {
        let elementNum = 0

        for (let i = 0, len = this.fixedColumnWidths.length; i < len; i++) {
          let element = rowElement.children[elementNum]
          const colSpan = element.colSpan
          let columnWidths = this.fixedColumnWidths[i]
          if (colSpan > 1) {
            for (let j = 1; j < colSpan; j++) {
              columnWidths += this.fixedColumnWidths[++i]
            }
          }
          element.style.width = columnWidths + (colSpan - 1) + 'px'
          elementNum++
        }
      }

      this.$refs.tableHeader.appendChild(this.$refs.thead)
      this.$refs.table.appendChild(this.$refs.tbody)
      this.$refs.tableWrapper.classList.add('fixed')
      this.$refs.tableWrapper.classList.remove('prepare', 'hidden')
      this.$refs.table.addEventListener('scroll', this.onScrollTable)
    },
    onScrollTable (event) {
      this.$refs.tableHeader.style.marginLeft = (-1 * this.$refs.table.scrollLeft) + 'px'
    }
  }
}

</script>
<style scoped>
  .table-wrapper {
    overflow: hidden;
    border: 1px solid #c0d5ef;
  }

  .table-wrapper.prepare {
    visibility: hidden;
    overflow: scroll;
  }

  .table-wrapper th,
  .table-wrapper td {
    white-space: nowrap;
  }

  .table-wrapper.fixed {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .table-wrapper.fixed table {
    display: flex;
    flex-direction: column;
    min-width: 100%;
    visibility: visible;
  }

  .table-wrapper.fixed table thead,
  .table-wrapper.fixed table tbody {
    display: flex;
    flex-direction: column;
  }

  .table-wrapper.fixed table tr {
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    align-items: stretch;
  }

  .table-wrapper.fixed table tr > th,
  .table-wrapper.fixed table tr > td {
    display: flex;
    flex-shrink: 0;
    flex-grow: 1;
    align-items: center;
  }

  .table-wrapper.fixed table thead {
    padding-right: 17px;
  }

  .table-wrapper.fixed table.table-header {
    flex-shrink: 0;
    background: #e3ebf4;
  }

  .table-wrapper.fixed table.table-body {
    overflow-y: scroll;
    overflow-x: auto;
    height: inherit;
    flex-grow: 1;
    background: #fff;
  }

  .table-wrapper th,
  .table-wrapper td {
    padding: 16px 20px;
    font-size: 0.88rem;
  }

  .table-wrapper th,
  .table-wrapper td {
    border-right: 1px solid #c0d5ef;
  }

  .table-wrapper.fixed table.table-header,
  .table-wrapper tr > td,
  .table-wrapper tbody > tr > th {
    border-bottom: 1px solid #c0d5ef;
  }

  .table-wrapper th:first-child,
  .table-wrapper td:first-child {
    font-size: 0.88rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/table/fixed-header-table.vue